import imgComputer from '@/assets/img/gifts/gift-config/computador.png'
import imgParty from '@/assets/img/gifts/gift-config/festa.png'
import imgThinkingFace from '@/assets/img/gifts/gift-config/pensativo.png'
import imgHotFace from '@/assets/img/gifts/gift-config/calor.png'
import imgMoneyFace from '@/assets/img/gifts/gift-config/dinheiro.png'
import imgSadFace from '@/assets/img/gifts/gift-config/chateado.png'

export default [
  {
    type: 'prefiro_produtos',
    image: imgComputer,
    label: 'Prefiro receber em produto e não em dinheiro;',
  },
  {
    type: 'vou_ativar_futuramente',
    image: imgParty,
    label: 'Vou ativar minha lista futuramente (próximo do meu casamento);',
  },
  {
    type: 'nao_entendi_como_funciona',
    image: imgThinkingFace,
    label: 'Não entendi muito bem como a lista funciona;',
  },
  {
    type: 'achei_dificil_montar',
    image: imgHotFace,
    label: 'Achei a lista muito difícil de editar;',
  },
  {
    type: 'taxa_muito_alta',
    image: imgMoneyFace,
    label: 'Achei as taxas muito altas;',
  },
  {
    type: 'nao_quero_paypal',
    image: imgSadFace,
    label: 'Não tenho e não quero criar uma conta no PayPal.',
  },
]
